<div class="relative">
    <svg
        viewBox="0 0 72 73"
        fill="none"
        class="size-12 hover:scale-105 transition-[transform,colors] cursor-pointer"
        xmlns="http://www.w3.org/2000/svg"
        (click)="cartService.toggleCart()"
        (click)="umami.track('navbar-cart-icon-click')"
    >
        <circle
            cx="36"
            cy="36.685"
            r="36"
            class="fill-primary hover:fill-primary-darker"
        />
        <path
            d="M18 18h2.395c.45 0 .676 0 .858.083.16.073.295.19.39.339.108.168.14.39.204.837l.867 6.074m0 0 1.929 14.175c.244 1.798.367 2.698.797 3.375.379.596.922 1.07 1.564 1.365.729.335 1.637.335 3.452.335h15.69c1.727 0 2.591 0 3.297-.31a3.67 3.67 0 0 0 1.543-1.277c.437-.635.599-1.484.922-3.182l2.427-12.74c.114-.597.17-.896.088-1.13a.92.92 0 0 0-.403-.486c-.213-.125-.518-.125-1.126-.125zm9.953 27.5a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0m14.666 0a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0"
            stroke="#fff"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
    <div
        class="top-0 right-0 absolute flex justify-center items-center bg-primary shadow-sm -mt-2 -mr-2 border rounded-full w-5 h-5 font-semibold text-white text-xs"
        id="cart-item-amount"
    >
        {{ cartService.itemCount() }}
    </div>
</div>
